import script from "./ScrollTopBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTopBtn.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTopBtn.vue?vue&type=style&index=0&id=d417beec&scoped=true&lang=css"

import exportComponent from "/home/tml/work/WP-plugins/wpaprsdb/wpaprsdb/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d417beec"]])

export default __exports__